import React from 'react';
import { RegularButton } from 'fronton-react';
import { MagnifyingGlassIcon } from '@fronton/icons-react';

export interface SubmitButtonProps {
  onSubmitRequest: () => void;
}

export const SubmitButton = ({ onSubmitRequest }: SubmitButtonProps) => (
  <RegularButton
    data-qa="search-submit-button"
    type="submit"
    iconOnly
    variant="accent"
    onClick={onSubmitRequest}
    label="Поиск">
    <MagnifyingGlassIcon />
  </RegularButton>
);
